require( 'slick-carousel-latest' );
$( () => {
  $( window ).on( 'load', () => {
    if ( $( '.bs-related-posts__items[data-slick]' ).length ) {
      $( '.bs-related-posts__items[data-slick]' )
        .not( '.bs-section--blog-inner-interested-post .bs-related-posts__items' ).slick();
    }
  } );
} );